import { Group, TreeNodeData, useMantineTheme } from '@mantine/core'
import { useMemo } from 'react'

interface RenderNodeProps {
  node: TreeNodeData
  level: number
  elementProps: React.HTMLAttributes<HTMLDivElement>
  data: any
}

const RenderNode: React.FC<RenderNodeProps> = ({ node, level, elementProps, data }) => {
  const theme = useMantineTheme()
  const markLastBranchLeafs = (nodes: TreeNodeData[], lastBranchLeafs: string[] = []) => {
    nodes.forEach(nd => {
      if (nd.children && nd.children.length > 0) {
        markLastBranchLeafs(nd.children, lastBranchLeafs)
        lastBranchLeafs.push(nd.children[nd.children.length - 1].value)
      }
    })
    return lastBranchLeafs
  }

  const lastBranchLeafs = useMemo(() => markLastBranchLeafs(data), [data])
  const isCurrentLastBranchLeaf = lastBranchLeafs.includes(node.value)

  return (
    <Group gap={5} {...elementProps}>
      <span
        style={
          isCurrentLastBranchLeaf
            ? {
                marginTop: 5,
                paddingLeft: node.value === 'Root' ? 0 : 15,
                position: 'relative',
              }
            : {
                marginTop: 5,
                borderLeft:
                  node.value === 'Root' ? 'none' : `1px solid ${theme.colors.l1Primary[0]}`,
                paddingLeft: node.value === 'Root' ? 0 : 15,
                position: 'relative',
                borderLeftStyle: node.value === 'Root' ? 'none' : 'double',
              }
        }
      >
        {node.label}

        <>
          {level > 1 && !isCurrentLastBranchLeaf && (
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '0px',
                width: '10px',
                borderLeftStyle: 'double',
                borderTop: `1px solid ${theme.colors.l1Primary[0]}`,
                transform: 'translateY(-50%)',
              }}
            />
          )}
          {level > 2 && (
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '-33px',
                width: '20px',
                borderLeft: `1px solid ${theme.colors.l1Primary[0]}`,
                borderTop: `1px solid ${theme.colors.l1Primary[0]}`,
                transform: 'translateY(-50%) rotate(90deg)',
              }}
            />
          )}
          {isCurrentLastBranchLeaf && (
            <div
              style={{
                position: 'absolute',
                top: '0',
                left: '0px',
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  width: '1px',
                  height: '12px',
                  backgroundColor: theme.colors.l1Primary[0],
                  verticalAlign: 'top',
                }}
              />
              <span
                style={{
                  paddingLeft: 10,
                  display: 'inline-block',
                  borderTop: `1px solid  ${theme.colors.l1Primary[0]}`,
                  verticalAlign: 'middle',
                }}
              />
            </div>
          )}
        </>
      </span>
    </Group>
  )
}

export default RenderNode
